import { ADD_ACCOUNT_PAGE } from 'src/constants';
import { STUDIO_REFERRER } from 'src/routes/onboarding/setup/constants';
import { UrlUtils } from 'src/utils';

/**
 * Studio variant of the "log in to another workspace" (`/add-account`) route.
 * `/add-account` renders `OnboardingLoginPage`, which shows the passwordless
 * Studio login screen only when `referrer=studio` is present — so the sidebar
 * must route through this rather than the bare `/add-account` path.
 */
export const buildStudioAddAccountPath = (): string =>
  `${ADD_ACCOUNT_PAGE}?${UrlUtils.FormatUrlQueryToString({
    referrer: STUDIO_REFERRER,
  })}`;
